export const toUpperCase = (s) => String(s).toUpperCase();
